import styled from '@emotion/styled';
import { SLIDE_HEIGHT } from './utils/constants';
import { Div } from '../../../layouts';

export const SlideContainer = styled(Div)`
    height: ${SLIDE_HEIGHT};

    & div.od-slide-container {
        top: 0;
    }

    & div.odf-box-opacity {
        margin-left: 1px;
    }
`;

export const GradientContainer = styled(Div)`
    height: ${SLIDE_HEIGHT};
    bottom: 0;
    left: 0;
    right: 0;
`;

export const getBackgroundComponent = (imageUri) => styled(Div)`
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    overflow: hidden;
    ${imageUri ? `background-image: url('${imageUri}');` : ''}
    background-size: 1920px auto;
    background-position: center calc(50% + 41px);

    @media (min-width: 1920px) {
        background-size: cover;
    }
`;
